import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TimeScanningService } from "../../shared/data.service";
import { ScanPointManualTableRequest } from "../../shared/ScanPointManualTableRequest";

@Component({
	selector: "caass-scan-point-manual-selector",
	templateUrl: "./scan-point-manual-selector.component.html",
	styleUrls: ["./scan-point-manual-selector.component.css"],
})
export class ScanPointManualSelectorComponent implements OnInit {
	constructor(private scanService: TimeScanningService) {}

	ngOnInit(): void {
		this.loadMain();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() FacilityID: any;

	AudienceMode: string = "Student"; //Student | Staff

	ActiveID: number = 1;
	lstActive: any = [
		{
			ID: -1,
			Desc: "Any",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	Processing: boolean = false;
	TableLoading: boolean = false;

	MainLoading: boolean = true;
	SelectedSchool: any;
	lstSchool: any = [];

	ContainerLoading: boolean = false;
	SelectedContainer: any;
	lstContainer: any = [];

	FacilityLoading: boolean = false;
	SelectedFacility: any;
	lstFacility: any = [];

	DynamicGroupLoading: boolean = false;
	SelectedDynamicGroup: any;
	lstDynamicGroup: any = [];

	DynamicValueLoading: boolean = false;
	SelectedDynamicValue: any;
	lstDynamicValue: any = [];

	FilterText: string = "";

	//
	// Table
	//
	@Output() PersonSelected: EventEmitter<any> = new EventEmitter();
	SelectedPersonExtended: any;

	lstTable: any = [];
	pagerows: any = 5;
	pagefirst: any = 0;
	SelectedPerson: any;
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ID", header: "ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
	];

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	//Load School List (+ All Schools, Container, Facility)
	loadMain() {
		this.MainLoading = true;

		var result = this.scanService.ScanPointManualSchoolSelectList();
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				if (this.lstSchool.length > 0) {
					this.SelectedSchool = this.lstSchool[0];
				}

				this.MainLoading = false;
			},
			(error) => {
				this.MainLoading = false;
			}
		);
	}

	loadContainer() {
		this.ContainerLoading = true;

		var result = this.scanService.ScanPointManualContainerSelectList();
		result.subscribe(
			(response) => {
				this.lstContainer = response;

				if (this.lstContainer.length > 0) {
					this.SelectedContainer = this.lstContainer[0];
				}

				this.ContainerLoading = false;
			},
			(error) => {
				this.ContainerLoading = false;
			}
		);
	}

	loadFacility() {
		this.FacilityLoading = true;

		var result = this.scanService.ScanPointManualFacilitySelectList();
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				if (this.lstFacility.length > 0) {
					this.SelectedFacility = this.lstFacility[0];
				}

				this.FacilityLoading = false;
			},
			(error) => {
				this.FacilityLoading = false;
			}
		);
	}

	loadDynamicGroup() {
		this.DynamicGroupLoading = true;

		this.SelectedDynamicGroup = null;
		this.lstDynamicGroup = [];
		this.SelectedDynamicValue = null;
		this.lstDynamicValue = [];

		var AudienceID = this.AudienceMode == "Student" ? 1 : 2;

		var result = this.scanService.ScanPointManualDynamicGroupSelectList(AudienceID);
		result.subscribe(
			(response) => {
				this.lstDynamicGroup = response;

				if (this.lstDynamicGroup.length > 0) {
					this.SelectedDynamicGroup = this.lstDynamicGroup[0];
					this.loadDynamicValue();
				}

				this.DynamicGroupLoading = false;
			},
			(error) => {
				this.DynamicGroupLoading = false;
			}
		);
	}

	loadDynamicValue() {
		this.DynamicValueLoading = true;

		var result = this.scanService.ScanPointManualDynamicValueSelectList("", this.SelectedDynamicGroup.DynamicGroupSQL, this.SelectedSchool.ID);
		result.subscribe(
			(response) => {
				this.lstDynamicValue = response;

				if (this.lstDynamicValue.length > 0) {
					this.SelectedDynamicValue = this.lstDynamicValue[0];
				}

				this.DynamicValueLoading = false;
			},
			(error) => {
				this.DynamicValueLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	onSearch() {
		this.onRowUnselect(null);
		this.lstTable = [];

		var DynamicGroupID = 0;
		var DynamicValueID = 0;

		//
		//Container
		//
		if (this.SelectedSchool.ID == -2) {
			DynamicGroupID = this.SelectedContainer.ID;
		}
		//
		//Facility
		//
		else if (this.SelectedSchool.ID == -1) {
			DynamicGroupID = this.SelectedFacility.ID;
		}
		//
		// Normal Person Selector
		//
		else if (this.SelectedSchool.ID > 0) {
			DynamicGroupID = this.SelectedDynamicGroup.DynamicGroupID;
			DynamicValueID = this.SelectedDynamicValue.ListID;
		}

		var parms: ScanPointManualTableRequest = {
			AudienceID: this.AudienceMode == "Student" ? 1 : 2,
			Active: this.ActiveID,
			SchoolID: this.SelectedSchool.ID,
			DynamicGroupID: DynamicGroupID,
			DynamicValueID: DynamicValueID,
			FilterText: this.FilterText,
		};

		this.TableLoading = true;

		var result = this.scanService.ScanPointManualTableSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstTable = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		if (this.SelectedSchool != null) {
			if (this.SelectedSchool.ID == -2) {
				this.loadContainer();
			} else if (this.SelectedSchool.ID == -1) {
				this.loadFacility();
			} else {
				this.loadDynamicGroup();
			}
		}
	}

	onAudienceOptionChange(val) {
		this.AudienceMode = val;

		if (this.SelectedSchool != null && this.SelectedSchool.ID > 0) {
			this.loadDynamicGroup();
		}
	}

	onDynamicGroupChange(val) {
		this.SelectedDynamicGroup = val;

		this.loadDynamicValue();
	}

	//
	// Table
	//
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPerson = val.data;
		this.PersonSelected.emit(this.SelectedPerson);
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
		this.PersonSelected.emit(this.SelectedPerson);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////
	IsLoading() {
		return (
			this.MainLoading == true ||
			this.ContainerLoading == true ||
			this.FacilityLoading == true ||
			this.DynamicGroupLoading == true ||
			this.DynamicValueLoading == true ||
			this.TableLoading == true ||
			this.Processing == true
		);
	}

	AnySelected() {
		return this.SelectedPerson != null;
	}
	/////////////////////////////////////////////////////////////////
}
